import React from "react";

import OnboardingAddOfflineMerchant from "pages/onboarding/application-form/add-offline-merchant/AddOfflineMerchant";
import OnboardingAddOnlineMerchant from "pages/onboarding/application-form/add-online-merchant/AddOnlineMerchant";
import OnboardingAddDevice from "pages/onboarding/application-form/add-device/AddDevice";
import OnboardingAddOutlet from "pages/onboarding/application-form/add-outlet/AddOutlet";
import OnboardingAddOfflinePayment from "pages/onboarding/application-form/add-offline-payment/AddOfflinePayment";
import OnboardingAddOnlinePayment from "pages/onboarding/application-form/add-online-payment/AddOnlinePayment";
import OnboardingAll from "pages/onboarding/application-list/all/All";
import OnboardingSaved from "pages/onboarding/application-list/saved/Saved";
import OnboardingProcessing from "pages/onboarding/application-list/processing/Processing";
import OnboardingCompleted from "pages/onboarding/application-list/completed/Completed";
import OnboardingRejected from "pages/onboarding/application-list/rejected/Rejected";
import OnboardingWithdrawn from "pages/onboarding/application-list/withdrawn/Withdrawn";
import OnboardingPendingPayment from "pages/onboarding/application-list/pending-payment/PendingPayment";
import OnboardingPendingInstallation from "pages/onboarding/application-list/pending-installation/PendingInstallation";
import OnboardingInstallationComfirmationLetter from "pages/onboarding/installation-confirmation-letter/InstallationConfirmationLetter";
import OnboardingApprovedKycApplication from "pages/onboarding/approved-kyc-application/ApprovedKycApplication";
import OnboardingMerchantDocument from "pages/onboarding/merchant-document/MerchantDocument";

import RoleCreate from "pages/roles-and-permissions/roleCreate/roleCreate";
import RoleManagement from "pages/roles-and-permissions/roleManagement/roleManagement";

import MerchantManagementAgents from "pages/merchant-management/agents/agents/Agents";
import MerchantManagementAgentsDetail from "pages/merchant-management/agents/agents-detail/AgentsDetail";
import MerchantManagementAddAgent from "pages/merchant-management/agents/add-agent/AddAgent";

import MerchantManagementOfflineMerchants from "pages/merchant-management/merchants/offline-merchants/OfflineMerchants";
import MerchantManagementOnlineMerchants from "pages/merchant-management/merchants/online-merchants/OnlineMerchants";

import MerchantManagementOfflineMerchantDetail from "pages/merchant-management/merchants/offline-merchant-detail/OfflineMerchantDetail";
import MerchantManagementOnlineMerchantDetail from "pages/merchant-management/merchants/online-merchant-detail/OnlineMerchantDetail";
import MerchantManagementAddOfflineMerchant from "pages/merchant-management/merchants/add-offline-merchant/AddOfflineMerchant";
import MerchantManagementAddOnlineMerchant from "pages/merchant-management/merchants/add-online-merchant/AddOnlineMerchant";
import MerchantManagementMerchantProfile from "../pages/merchant-management/merchants/merchant-profile/merchant-profile";
import MerchantManagementOfflineMerchantProcessorAccounts from "pages/merchant-management/merchants/offline-merchant-processor-accounts/OfflineMerchantProcessorAccounts";

import MerchantManagementOfflineEmployees from "pages/merchant-management/employees/offline-employees/OfflineEmployees";
import MerchantManagementOnlineEmployees from "pages/merchant-management/employees/online-employees/OnlineEmployees";
import MerchantManagementOfflineEmployeeDetail from "pages/merchant-management/employees/offline-employee-detail/OfflineEmployeeDetail";
import MerchantManagementOnlineEmployeeDetail from "pages/merchant-management/employees/online-employee-detail/OnlineEmployeeDetail";

import MerchantManagementAddOfflineEmployee from "pages/merchant-management/employees/add-offline-employee/AddOfflineEmployee";
import MerchantManagementAddOnlineEmployee from "pages/merchant-management/employees/add-online-employee/AddOnlineEmployee";

import AccountManagementSales from "pages/account-management/sales/Sales";
import AccountManagementReferrer from "pages/account-management/referrer/Referrer";
import AccountManagementServiceIntegrator from "pages/account-management/service-integrator/ServiceIntegrator";
import AccountManagementMaintenanceParty from "pages/account-management/maintenance-party/MaintenanceParty";

import TransactionsOfflinePayments from "pages/transactions/offline-payments/OfflinePayments";
import TransactionsOfflinePaymentsDetails from "pages/transactions/offline-payments-details/OfflinePaymentsDetails";
import TransactionsOfflineTransactions from "pages/transactions/offline-transactions/OfflineTransactions";
import TransactionsOnlineOrders from "pages/transactions/online-orders/OnlineOrders";
import TransactionsOnlineOrderDetails from "pages/transactions/online-order-details/OnlineOrderDetails";
import TransactionsOnlineTransactions from "pages/transactions/online-transactions/OnlineTransactions";

import FinanceDebitNotesPendingApproval from "pages/finance/debit-notes/pending-approval/PendingApproval";
import FinanceDebitNotesApproved from "pages/finance/debit-notes/approved/Approved";
import FinanceDebitNotesFinished from "pages/finance/debit-notes/finished/Finished";
import FinanceSettlementPlansAll from "pages/finance/settlement-plans/all/All";
import FinanceSettlementPlansPendingApproval from "pages/finance/settlement-plans/pending-approval/PendingApproval";
import FinanceSettlementPlansChangeLog from "pages/finance/settlement-plans/change-log/ChangeLog";
import FinanceByTransactionDate from "pages/finance/reconciliation/by-transaction-date/ByTransactionDate";
import FinanceBySettlementDate from "pages/finance/reconciliation/by-settlement-date/BySettlementDate";
import FinanceTransactionSummary from "pages/finance/transaction-summary/TransactionSummary";
import FinanceRefund from "pages/finance/refund/Refund";
import FinanceBankSubmission from "pages/finance/bank-submission/BankSubmission";
import FinanceMerchantMdr from "pages/finance/merchant-mdr/MerchantMdr";
import FinancePaymentGatewayCost from "pages/finance/payment-gateway-cost/PaymentGatewayCost";
import FinanceFxRate from "pages/finance/fx-rate/FxRate";

import Dashboard from "pages/tms/dashboard/Dashboard";
import Devices from "pages/tms/devices/Devices";
import RemoteView from "pages/tms/remote-view/RemoteView";
import Applications from "pages/tms/applications/Applications";
import Customers from "pages/tms/customers/Customers";
import RKI from "pages/tms/RKI/RKI";
import UserManagement from "pages/tms/user-management/user-management";

import ToolsTerminal from "pages/tools/notice/terminal/Terminal";
import ToolsWeb from "pages/tools/notice/web/Web";
import ToolsMassEmail from "pages/tools/email/mass-email/MassEmail";
import ToolsOfflineEmailTemplate from "pages/tools/email/offline-email-template/OfflineEmailTemplate";
import ToolsOnlineEmailTemplate from "pages/tools/email/online-email-template/OnlineEmailTemplate";
import ToolsMerchantReportEmail from "pages/tools/merchant-report-email/MerchantReportEmail";
import ToolsOfflineStatementPdf from "pages/tools/offline-statement-pdf/OfflineStatementPdf";
import ToolsOnlineStatementPdf from "pages/tools/online-statement-pdf/OnlineStatementPdf";
import ToolsMdrCalculator from "pages/tools/mdr-calculator/MerCalculator";
import ToolsCardSplit from "pages/tools/card-split/CardSplit";

import PaperRollRequestList from "pages/tools/paperRoll/paperRollRequestList/paperRollRequestList";
import PaperRollRequestCreate from "pages/tools/paperRoll/paperRollRequestCreate/paperRollRequestCreate";

import AnalyticsSalesPerformance from "../pages/analytics/sales-performance/SalesPerformance";
import AnalyticsSalesAchievement from "../pages/analytics/sales-achievement/SalesAchievement";
import AnalyticsReferrerPerformance from "../pages/analytics/referrer-performance/ReferrerPerformance";
import AnalyticsReferrerTransactionVolume from "../pages/analytics/referrer-transaction-volume/ReferrerTransactionVolume";
import AnalyticsTransactionActivity from "../pages/analytics/transaction-activity/TransactionActivity";
import AnalyticsLowActivityMerchant from "../pages/analytics/low-activity-merchant/LowActivityMerchant";
import AnalyticsDataOverviewAndExport from "../pages/analytics/data-overview-and-export/DataOverviewAndExport";
import AnalyticsSmeUsage from "../pages/analytics/sme-usage/SmeUsage";
// import AnalyticsDailyMerchantInfo from "../pages/analytics/daily-merchant-info/DailyMerchantInfo";
// import AnalyticsTransactionByCardType from "../pages/analytics/transaction-by-card-type/TransactionByCardType";
import AnalyticsLowActivityMerchantDataLake from "../pages/analytics/low-activity-merchant-data-lake/LowActivityMerchantDataLake";
import AnalyticsSystemStatistics from "../pages/analytics/system-statistics/system-statistics";
import AnalyticsEmployee from "../pages/analytics/employee/Employee";
import AnalyticsMerchantDetail from "../pages/analytics/transaction-activity/detail/MerchantDetail/MerchantDetail";
import AnalyticsDataDashboard from "pages/analytics/data-dashboard/AnalyticsDataDashboard";

import DisputeList from "../pages/compliance/disputeList/DisputeList";
import DisputeDetail from "../pages/compliance/disputeDetail/DisputeDetail";

import Roles from "../pages/roles-and-permissions/roles/Roles";
import Users from "../pages/roles-and-permissions/users/Users";
import InternalReports from "../pages/internal-reports/InternalReports";

const tabMapping = (key, handlePageChanging) => {
  const map = {
    "/onboarding/application-form/add-offline-merchant": (
      <OnboardingAddOfflineMerchant path={key} />
    ),
    "/onboarding/application-form/add-online-merchant": (
      <OnboardingAddOnlineMerchant path={key} />
    ),

    "/onboarding/application-form/add-device": (
      <OnboardingAddDevice path={key} />
    ),
    "/onboarding/application-form/add-outlet": (
      <OnboardingAddOutlet path={key} />
    ),
    "/onboarding/application-form/add-offline-payment": (
      <OnboardingAddOfflinePayment path={key} />
    ),
    "/onboarding/application-form/add-online-payment": (
      <OnboardingAddOnlinePayment path={key} />
    ),
    "/onboarding/application-list/all": <OnboardingAll path={key} />,
    "/onboarding/application-list/saved": <OnboardingSaved path={key} />,
    "/onboarding/application-list/processing": (
      <OnboardingProcessing path={key} />
    ),
    "/onboarding/application-list/completed": (
      <OnboardingCompleted path={key} />
    ),
    "/onboarding/application-list/rejected": <OnboardingRejected path={key} />,
    "/onboarding/application-list/withdrawn": (
      <OnboardingWithdrawn path={key} />
    ),
    "/onboarding/application-list/pending-payment": (
      <OnboardingPendingPayment path={key} />
    ),
    "/onboarding/application-list/pending-installation": (
      <OnboardingPendingInstallation path={key} />
    ),
    "/onboarding/installation-confirmation-letter": (
      <OnboardingInstallationComfirmationLetter path={key} />
    ),
    "/onboarding/approved-kyc-application": (
      <OnboardingApprovedKycApplication path={key} />
    ),
    "/onboarding/merchant-document": <OnboardingMerchantDocument path={key} />,

    "/roles-and-permissions/roleCreate/roleCreate": (
      <RoleCreate path={key} redirectFn={handlePageChanging} />
    ),

    "/roles-and-permissions/roleManagement/roleManagement": (
      <RoleManagement path={key} redirectFn={handlePageChanging} />
    ),
    "/merchant-management/agents/agents": (
      <MerchantManagementAgents path={key} redirectFn={handlePageChanging} />
    ),
    "/merchant-management/agents/agents-detail": (
      <MerchantManagementAgentsDetail
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/agents/add-agent": (
      <MerchantManagementAddAgent path={key} redirectFn={handlePageChanging} />
    ),
    "/merchant-management/merchants/offline-merchants": (
      <MerchantManagementOfflineMerchants
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/merchants/online-merchants": (
      <MerchantManagementOnlineMerchants
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/merchants/offline-merchant-detail": (
      <MerchantManagementOfflineMerchantDetail
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/merchants/online-merchant-detail": (
      <MerchantManagementOnlineMerchantDetail
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/merchants/offline-merchant-processor-accounts": (
      <MerchantManagementOfflineMerchantProcessorAccounts
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/merchants/add-offline-merchant": (
      <MerchantManagementAddOfflineMerchant path={key} />
    ),
    "/merchant-management/merchants/add-online-merchant": (
      <MerchantManagementAddOnlineMerchant path={key} />
    ),
    "/merchant-management/employees/offline-employees": (
      <MerchantManagementOfflineEmployees
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/employees/online-employees": (
      <MerchantManagementOnlineEmployees
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/employees/offline-employee-detail": (
      <MerchantManagementOfflineEmployeeDetail
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/employees/online-employee-detail": (
      <MerchantManagementOnlineEmployeeDetail
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/merchant-management/employees/add-offline-employee": (
      <MerchantManagementAddOfflineEmployee path={key} />
    ),
    "/merchant-management/employees/add-online-employee": (
      <MerchantManagementAddOnlineEmployee path={key} />
    ),
    "/merchant-management/merchants/merchant-profile": (
      <MerchantManagementMerchantProfile
        path={key}
        redirectFn={handlePageChanging}
      />
    ),

    "/account-management/sales": <AccountManagementSales path={key} />,
    "/account-management/referrer": <AccountManagementReferrer path={key} />,
    "/account-management/service-integrator": (
      <AccountManagementServiceIntegrator path={key} />
    ),
    "/account-management/maintenance-party": (
      <AccountManagementMaintenanceParty path={key} />
    ),

    "/transactions/offline-payments": (
      <TransactionsOfflinePayments path={key} redirectFn={handlePageChanging} />
    ),
    "/transactions/offline-payments-details": (
      <TransactionsOfflinePaymentsDetails
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/transactions/offline-transactions": (
      <TransactionsOfflineTransactions
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/transactions/online-orders": (
      <TransactionsOnlineOrders path={key} redirectFn={handlePageChanging} />
    ),
    "/transactions/online-order-details": (
      <TransactionsOnlineOrderDetails
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/transactions/online-transactions": (
      <TransactionsOnlineTransactions
        path={key}
        redirectFn={handlePageChanging}
      />
    ),

    "/finance/debit-notes/pending-approval": (
      <FinanceDebitNotesPendingApproval path={key} />
    ),
    "/finance/debit-notes/approved": <FinanceDebitNotesApproved path={key} />,
    "/finance/debit-notes/finished": <FinanceDebitNotesFinished path={key} />,
    "/finance/settlement-plans/all": (
      <FinanceSettlementPlansAll path={key} redirectFn={handlePageChanging} />
    ),
    "/finance/settlement-plans/pending-approval": (
      <FinanceSettlementPlansPendingApproval
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/finance/settlement-plans/change-log": (
      <FinanceSettlementPlansChangeLog path={key} />
    ),
    "/finance/reconciliation/by-transaction-date": (
      <FinanceByTransactionDate path={key} />
    ),
    "/finance/reconciliation/by-settlement-date": (
      <FinanceBySettlementDate path={key} />
    ),
    "/finance/transaction-summary": <FinanceTransactionSummary path={key} />,
    "/finance/refund": <FinanceRefund path={key} />,
    "/finance/bank-submission": <FinanceBankSubmission path={key} />,
    "/finance/merchant-mdr": (
      <FinanceMerchantMdr path={key} redirectFn={handlePageChanging} />
    ),
    "/finance/payment-gateway-cost": <FinancePaymentGatewayCost path={key} />,
    "/finance/fx-rate": <FinanceFxRate path={key} />,

    "/tools/notice/terminal": <ToolsTerminal path={key} />,
    "/tools/notice/web": <ToolsWeb path={key} />,
    "/tools/email/mass-email": <ToolsMassEmail path={key} />,
    "/tools/email/offline-email-template": (
      <ToolsOfflineEmailTemplate path={key} />
    ),
    "/tools/email/online-email-template": (
      <ToolsOnlineEmailTemplate path={key} />
    ),
    "/tools/merchant-report-email": <ToolsMerchantReportEmail path={key} />,
    "/tools/offline-statement-pdf": <ToolsOfflineStatementPdf path={key} />,
    "/tools/online-statement-pdf": <ToolsOnlineStatementPdf path={key} />,
    "/tools/mdr-calculator": <ToolsMdrCalculator path={key} />,
    "/tools/card-split": <ToolsCardSplit path={key} />,
    "/tools/paperRoll/paperRollRequestList/paperRollRequestList": (
      <PaperRollRequestList path={key} redirectFn={handlePageChanging} />
    ),
    "/tools/paperRoll/paperRollRequestCreate/paperRollRequestCreate": (
      <PaperRollRequestCreate path={key} redirectFn={handlePageChanging} />
    ),

    "/analytics/sales-performance": <AnalyticsSalesPerformance path={key} />,
    "/analytics/sales-achievement": <AnalyticsSalesAchievement path={key} />,
    "/analytics/referrer-performance": (
      <AnalyticsReferrerPerformance path={key} />
    ),
    "/analytics/referrer-transaction-volume": (
      <AnalyticsReferrerTransactionVolume
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/analytics/transaction-activity": (
      <AnalyticsTransactionActivity
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/analytics/low-activity-merchant": (
      <AnalyticsLowActivityMerchant
        path={key}
        redirectFn={handlePageChanging}
      />
    ),
    "/analytics/transaction-activity/merchant-detail": (
      <AnalyticsMerchantDetail path={key} />
    ),
    "/analytics/data-overview-and-export": (
      <AnalyticsDataOverviewAndExport path={key} />
    ),
    "/analytics/sme-usage": <AnalyticsSmeUsage path={key} />,
    // "/analytics/daily-merchant-info": <AnalyticsDailyMerchantInfo path={key} />,
    // "/analytics/transaction-by-card-type": <AnalyticsTransactionByCardType path={key} />,
    "/analytics/employee": <AnalyticsEmployee path={key} />,
    "/analytics/low-activity-merchant-data-lake": (
      <AnalyticsLowActivityMerchantDataLake path={key} />
    ),
    "/analytics/system-statistics": <AnalyticsSystemStatistics path={key} />,
    "/analytics/weekly-statistics": (
      <AnalyticsDataDashboard path={key} type={"weeklySales"} />
    ),
    "/analytics/summary": (
      <AnalyticsDataDashboard path={key} type={"summary"} />
    ),
    "/analytics/internal-external": (
      <AnalyticsDataDashboard path={key} type={"internalExternal"} />
    ),
    "/analytics/salesperson": (
      <AnalyticsDataDashboard path={key} type={"salesperson"} />
    ),
    "/roles-and-permissions/roles": <Roles path={key} />,
    "/roles-and-permissions/users": <Users path={key} />,

    "/tms/dashboard": <Dashboard path={key} />,
    "/tms/devices": <Devices path={key} />,
    "/tms/remote-view": <RemoteView path={key} />,
    "/tms/applications": <Applications path={key} />,
    "/tms/customers": <Customers path={key} />,
    "/tms/RKI": <RKI path={key} />,
    "/tms/user": <UserManagement path={key} />,

    "/compliance/disputeList/DisputeList": (
      <DisputeList path={key} redirectFn={handlePageChanging} />
    ),
    "/compliance/disputeDetail/DisputeDetail": (
      <DisputeDetail path={key} redirectFn={handlePageChanging} />
    ),

    "/internal-reports/abnormal-offline-payment": (
      <InternalReports path={key} />
    ),
    "/internal-reports/abnormal-online-order": <InternalReports path={key} />,
    "/internal-reports/abnormal-agent-name": <InternalReports path={key} />,
    "/internal-reports/abnormal-br-number": <InternalReports path={key} />,
    "/internal-reports/abnormal-create-date": <InternalReports path={key} />,
    "/internal-reports/abnormal-merchant-legal-name": (
      <InternalReports path={key} />
    ),
    "/internal-reports/abnormal-order-trans-time": (
      <InternalReports path={key} />
    ),
    "/internal-reports/abnormal-settlement-merchant-mdr": (
      <InternalReports path={key} />
    ),
  };
  const pathkey = key.split("?")[0];
  return map[pathkey];
};

export default tabMapping;
//
